import React from 'react'
import classes from './AgentList.module.css'
// import serverUrl from '../../../serverUrl';
import userIcon from '../../../assets/userIcon.png';

import * as settings from '../../../settings'
const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV

const AgentList = (props) => {


    if (props.permissionType <= 3 || !props.groupSetting || !props.groupSetting.isGroupsSupported ||
        props.loggedAgent_groupList.find(loggedAgentGroup => props.agentItemGroupList.find(otherAgentGroup => otherAgentGroup._id === loggedAgentGroup._id))) {
        let isAgentOnline = props.listOfOnlineAgents.some(OnlineAgent => OnlineAgent.agentName === props.agentItemAgentName)
        let agentStatusClass = classes['user-img-offline']
        if (isAgentOnline) {
            agentStatusClass = classes['user-img-online']
        }
        else {
            agentStatusClass = classes['user-img-offline']
        }
        return (
            <div className={`${classes['agent-dropdown-item']} ${classes['agent-dropdown-item-pointer']}`} onClick={() => {props.onClick(props.agentItemAgentName)}} >
                <div>
                    {props.children}
                </div>
                <div className={`${classes['right-box']}`}>
                    <span className={`${classes['agent-name']}`}>{props.name}</span>
                    {/* <img  alt='Cant load img' src={serverUrl + '/users/avatar/' + props.agentItemAvatarName} onError={(event) => event.target.src = userIcon} className={`${agentStatusClass}`} /> */}
                    <img  alt='Cant load img' src={props.avatarImg ? serverUrl + `/users/${props.userId}/avatar` : userIcon} onError={(event) => event.target.src = userIcon} className={`${agentStatusClass}`} />
                </div>
                
            </div>
        )
    }
    else {
        return null
    }
}

export default AgentList